import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const BASE_URL = 'app-users/v1/teams';
const getTeamsKey = () => 'Teams';
const _fetchTeams = () => http.get(`${BASE_URL}`);
const getTeamsLeadFlows = () => getFromEarlyRequest(getTeamsKey(), () => _fetchTeams());
export default getTeamsLeadFlows;